import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import Checkout from './Checkout/Checkout';
import CheckoutOnline from './Checkout/CheckoutOnline';
import PreForm from './Form/PreForm';
import Login from './Login/Login';
import Main from './Main/Main';

import routes from '../constants/routes';
import { isJwtTokenStored } from '../helpers/authHelper';

const privateRoutes = [
    {
      path: routes.HOME,
      element: <Main />
    },
    {
      path: routes.PAYMENT_CREATE,
      element: <PreForm />
    },
    {
      path: routes.PAYMENT_CHECKOUT,
      element: <Checkout />
    },
    {
      path: routes.PAYMENT_CHECKOUT_ONLINE(':id'),
      element: <CheckoutOnline />
    },
    {
      path: routes.PAYMENT_CHECKOUT_CANCEL,
      element: <Checkout />
    }
  ];


function RequireAuth({children}) {
  //Location
  let location = useLocation();
  //Verifico si está token
  if(!isJwtTokenStored()){
    return <Navigate to={routes.LOGIN} state={{ from: location }} />
  }

  return children;
}

const Home = () => {
    return (
      <Routes>
          {
            privateRoutes.map(route => (
                <Route 
                    key={route.path}
                    exact
                    path={route.path}
                    element={
                      <RequireAuth>
                        { route.element }
                      </RequireAuth>
                    }
                />
            ))
          }
          <Route exact path={routes.LOGIN} element={<Login />}  />
          <Route
            path="*"
            render={() => (
              <Navigate to={routes.HOME} />
            )}
          />
      </Routes>
    );
};

export default Home;